import React from 'react';

export const UnemploymentInsuranceInfo = () => (
  <>
    <p>
      Vul een bedrag in tussen € 150 en € 2.500 met een maximum van 125% van het verzekerd bedrag bij arbeidsongeschiktheid.
    </p>
  </>
);
